// How DateSelector looks. INLINE: the one-month calendar of the guest flow (discounted days show
// their price). POPUP: New Booking's date popup (Figma 7278:213634) — two months side by side,
// discounted days show their percentage off.
export const CALENDAR_VARIANTS = {
  INLINE: "inline",
  POPUP: "popup"
}
